<template>
  <div>
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px">
      <div class="title-tab-experience-manager">ADMINISTRATOR</div>
      <div class="d-flex m__t--45">
        <template v-for="(tab, index) in tabMenu">
          <div
            v-if="tab.show"
            :key="tab.label"
            :class="[
              { 'm__r--35': index < tabMenu.length - 1 },
              tab.active ? 'tab-experience-manager-active' : 'tab-experience-manager'
            ]"
            @click="$router.replace(tab.url)"
          >
            {{ tab.label }}
          </div>
        </template>
      </div>
    </div>

    <div class="studio-page-administrator-content">
      <div class="custom-table-search">
        <v-server-table
          v-show="load_first"
          ref="layerServer"
          :columns="columns"
          :options="options"
          class="jTable"
          @loading="loading"
          @loaded="loaded">
          <div
            slot="beforeFilter"
            class="custom-search">
            <b-form
              inline
              @keypress.13.prevent="filter(filter_data)">
              <b-button
                class="btn grey btn-import-form m__r--5"
                @click="showModal">
                <i class="fa fa-plus fa-lg"/> Add
              </b-button>
              <j-select
                v-model="select_type"
                :disabled="false"
                :options="options_search"
                placeholder="Filter By"
                class="m__r--5"/>
              <b-form-group>
                <b-form-input
                  ref="filterInput"
                  v-model="filter_data"
                  placeholder="Search"
                  class="m__r--5"/>
              </b-form-group>
            </b-form>
          </div>

          <div
            slot="checkbox"
            slot-scope="props"
            class="jTableReport">
            <b-form-group>
              <b-form-checkbox-group v-model="selected_rows">
                <b-form-checkbox :value="props.row"/>
              </b-form-checkbox-group>
            </b-form-group>
          </div>

          <div
            slot="id"
            slot-scope="props"
            @click="$router.replace(`/administrator/layer/update/${props.row.id}`)">
            {{ props.row.id }}
          </div>

          <div
            slot="name"
            slot-scope="props"
            @click="$router.replace(`/administrator/layer/update/${props.row.id}`)">
            {{ props.row.name }}
          </div>

          <div
            slot="code"
            slot-scope="props"
            @click="$router.replace(`/administrator/layer/update/${props.row.id}`)">
            {{ props.row.code }}
          </div>

          <div
            slot="total_position"
            slot-scope="props"
            @click="$router.replace(`/administrator/layer/update/${props.row.id}`)">
            {{ props.row.total_organigram }}
          </div>

          <div
            slot="created_date"
            slot-scope="props"
            @click="$router.replace(`/administrator/layer/update/${props.row.id}`)">
            {{ props.row.created_date }}
          </div>

          <div
            slot="updated_date"
            slot-scope="props"
            @click="$router.replace(`/administrator/layer/update/${props.row.id}`)">
            {{ props.row.updated_date }}
          </div>
        </v-server-table>

        <div
          v-if="!load_first">
          <jLoadingTable/>
        </div>
      </div>
    </div>

    <j-layer-create
      v-if="isModalOpen"
      @closemodal="showModal"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import jApiLayer from '@/services/jApiLayer';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jProgressScreen from '@/components/progress-screen/jProgressScreen';
import jLayerCreate from '@/views/layer/jLayerCreate';

export default {
  components: {
    jLoadingTable,
    jProgressScreen,
    jLayerCreate,
  },
  data() {
    return {
      isModalOpen: false,
      select_type: 'name',
      options_search: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Code',
          value: 'code',
        },
        {
          text: 'Created Date',
          value: 'created_date',
        },
      ],
      filter_data: '',
      load_first: false,
      length_table: '',
      columns: ['id', 'name', 'code', 'total_position', 'created_date', 'updated_date'],
      options: {
        headings: {
          id: 'ID',
          name: 'NAME',
          code: 'CODE',
          total_position: 'TOTAL POSITION',
          created_date: 'CREATED DATE',
          updated_date: 'UPDATED DATE',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        filterable: true,
        sortable: ['name', 'code'],
        perPage: 10,
        perPageValues: [10, 20, 50, 100],
        rowClassCallback(row) {
          return `row-${row.id}`;
        },
        requestAdapter(data) {
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              column: data.orderBy ? data.orderBy : 'id',
              ascending: !!data.ascending,
              query: data.query ? data.query : '',
              query_type: '',
            },
          };
        },
        requestFunction(data) {
          const getListExample = jApiLayer.getListLayer(data);
          return getListExample.catch((e) => {
            this.dispatch('error', e);
            this.$store.commit('jStoreNotificationScreen/toggleStateProblem', e.message);
          });
        },
        responseAdapter({ data }) {
          if (data.length) {
            this.length_table = data.length;
          }
          return {
            data: data.data ? data.data : [],
            count: data.length,
          };
        },
        templates: {
          total_position(h, row) {
            const total = row.policies.length;
            return <div on-click={ () => this.$router.replace(`/company/organization/division/update/${row.id}`)}>{total}</div>;
          },
        },
      },
    };
  },
  computed: {
    ...mapState('jStoreLayer', ['layer_created', 'layer_updated', 'layer_deleted']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    ...mapState('jStoreLogin', ['profile_data']),

    role() {
      return Number(localStorage.getItem('userRole') || this.profile_data.userRole);
    },
    tabMenu() {
      return [
        { url: '/administrator', label: 'USER', show: true, active: false },
        { url: '/administrator/position', label: 'POSITION', show: true, active: false },
        { url: '/administrator/unit', label: 'UNIT', show: true, active: false },
        { url: '/administrator/location', label: 'LOCATION', show: true, active: false },
        { url: '/administrator/layer', label: 'LAYER', show: true, active: true },
        { url: '/administrator/company/profile', label: 'COMPANY', show: true, active: false },
        { url: '/administrator/company/settings', label: 'SETTINGS', show: this.role === 1, active: false },
      ];
    },
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.layerServer.setFilter('');
      }
    },

    layer_created() {
      this.refreshTable();
    },

    layer_updated() {
      this.refreshTable();
    },

    layer_deleted() {
      this.refreshTable();
    },

    load_first(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.filterInput.focus();
        }, 200);
      }
    },
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'toggleProblem', 'showLoading', 'hideLoading']),

    filter(val) {
      this.$refs.layerServer.setFilter(val);
    },

    loading(data) {
      const dataParam = data.pagination;
      dataParam.query_type = this.select_type;
      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded() {
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
        this.hideLoading();
      }
    },

    rowClick(data) {
      this.$router.replace(`/layer/update/${data.row.id}`);
    },

    refreshTable() {
      this.$refs.layerServer.getData();
    },
    showModal() {
      this.isModalOpen = !this.isModalOpen;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/layer/jLayerList.vue